import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError } from "rxjs";
import { environment } from "../../environments/environment";
import IManageModules from "../domain/ports/manage/i-manage-modules";
import { ApiResponse, PaginatedData } from "../domain/models/apiResponse";
import { CreateModuleDTO, ModuleItem, UpdateModuleDTO } from "../domain/models/moduleItem";

@Injectable({ providedIn: 'root' })
export class ModuleAdapterService implements IManageModules {
  private baseUrl = environment.urlApi;

  constructor(private http: HttpClient) {}
   

 getModules(
    pageIndex: number,
    pageSize: number
  ): Observable<ApiResponse<PaginatedData<ModuleItem>>> {
    return this.http.get<ApiResponse<PaginatedData<ModuleItem>>>(`${this.baseUrl}api/v1/Module`, {
      params: {
        pageIndex: pageIndex.toString(),
        pageSize: pageSize.toString()
      }
    }).pipe(
      catchError(err => {
        console.error("Error in getModulesPaged", err);
        throw err;
      })
    );
  }

 
}

